import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { userAtom, tokenAtom } from "../../global/globalState";
import Axios from "axios";

const Notices = () => {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [user, setUser] = useRecoilState(userAtom);

    const token = useRecoilValue(tokenAtom);
    console.log(user, "user");

    const notice = {
        title: name,
        description,
    };

    const addNotice = () => {
        Axios.post(`${process.env.REACT_APP_API_URL}/teacher/notices`, notice, {
            headers: {
                Authorization: "Bearer " + token,
            },
        })
            .then((res) => {
                console.log(res.data.response, "response");
                setUser(res.data.response);
                localStorage.setItem("user", JSON.stringify(res.data.response));
            })
            .catch((err) => {
                console.error(err);
            });
    };

    return (
        <div className="Notices">
            <div className="notices">
                <div className="notices-title">ALL NOTICES</div>
                <div className="notice-cards">
                    {user.notices &&
                        user.notices.map((notice) => (
                            <div key={notice._id} className="notice-card">
                                <div>
                                    <h3 className="notice-heading">
                                        {notice.title}
                                    </h3>
                                    <p>{notice.description}</p>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
            <div className="create-notice">
                <div className="create-notice-title">CREATE NOTICE</div>
                <div className="create-notice-form ">
                    <label htmlFor="name">Name of Notice</label>
                    <input
                        type="text"
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <label htmlFor="name">Description of Notice</label>
                    <textarea
                        type="text"
                        id="name"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                    <button
                        className="primary submit"
                        onClick={() => addNotice()}
                    >
                        CREATE
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Notices;
